export default __webpack_public_path__ + "ab4e766e6cc8318eb10ad4a8f86dda3b.svg";